const AUTH_BASE_URL = process.env.REACT_APP_URL_AUTH;

const PUBLIC_PATHS = [
  "/authentication/login",
  "/authentication/signup",
  "/authentication/google-login",
  "/authentication/forgot-password",
  "/authentication/reset-password"
];

export async function apiFetch(path, options = {}) {
  const fullUrl = `${AUTH_BASE_URL}${path}`;
  const defaultHeaders = {
    "Content-Type": "application/json",
  };

  const token = localStorage.getItem("token");

  const isPublic = PUBLIC_PATHS.includes(path);
  if (token && !isPublic) {
    defaultHeaders["Authorization"] = `Bearer ${token}`;
  }

  const res = await fetch(fullUrl, {
    headers: { ...defaultHeaders, ...(options.headers || {}) },
    ...options
  });

  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    const error = new Error(data.error?.message || "Request failed");
    error.data = data;
    throw error;
  }

  return data;
}